import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

import CalenderView from "Components/Common/CalenderView";
import Modal from "Components/Common/Modal";
import { FIRE_SAFETY_CONSUMER } from "common/constant";
import ConfirmationDialog from "Components/Common/ConfirmationDialog";
import FireSafetyConsumerAuditScheduler from "./FireSafetyConsumerAuditScheduler";

import { filterEmptyStrings } from "utils";

import {
  usePostRescheduleMutation,
  usePutAuditConfirmationMutation,
} from "apis/AuditSchedular";

const AuditSchedularApproval = ({
  applicationId,
  handleClose,
  developerBuilding,
  events = [],
  t,
}) => {
  const [addAuditDatesConfirmation, { isLoading: isAuditConfirming }] =
    usePutAuditConfirmationMutation();

  const [addAuditSchedule, { isLoading: isAuditScheduleAdding }] =
    usePostRescheduleMutation();

  const { roles } = useSelector((state) => state.Login);

  const [selectedScheduleDatesData, setSelectedScheduleDatesData] = useState(
    []
  );
  const [isRescheduleButtonClicked, setIsRescheduleButtonClicked] =
    useState(false);
  const [isApproveButtonClicked, setIsApproveButtonClicked] = useState(false);

  const submitHandlerForApproval = async () => {
    try {
      await addAuditDatesConfirmation(applicationId);
      setIsApproveButtonClicked(false);
      handleClose();
    } catch (error) {}
  };

  const submitHandlerForReschedule = async () => {
    try {
      await addAuditSchedule(
        filterEmptyStrings({
          buildingInformationId: applicationId,
          buildingSchedules: selectedScheduleDatesData,
        })
      );
      setIsRescheduleButtonClicked(false);
      handleClose();
    } catch (error) {}
  };

  return (
    <Modal
      isOpen
      handleClose={handleClose}
      maxWidth="lg"
      title="Audit Schedule Approval"
    >
      {isRescheduleButtonClicked && (
        <>
          {roles.includes(FIRE_SAFETY_CONSUMER) ? (
            <FireSafetyConsumerAuditScheduler
              handleClose={(isSubmitting) => {
                setIsRescheduleButtonClicked(false);
                if (isSubmitting) {
                  handleClose();
                }
              }}
              developerBuildingId={developerBuilding?.id}
            />
          ) : (
            <ConfirmationDialog
              message="Are you sure you want to Reschedule this dates?"
              onCancel={() => setIsRescheduleButtonClicked(false)}
              onConfirm={submitHandlerForReschedule}
              isOpen={isRescheduleButtonClicked}
              title="Warning"
              variant="warning"
              isLoading={isAuditScheduleAdding}
            />
          )}
        </>
      )}

      {isApproveButtonClicked && (
        <ConfirmationDialog
          message={
            roles.includes(FIRE_SAFETY_CONSUMER)
              ? t("Are you sure you want to approve this schedules?")
              : t(
                  "Are you sure you want to assign multiple buildings on same dates?"
                )
          }
          onCancel={() => setIsApproveButtonClicked(false)}
          onConfirm={submitHandlerForApproval}
          isOpen={isApproveButtonClicked}
          title="Warning"
          variant="warning"
          isLoading={isAuditConfirming}
        />
      )}

      <CalenderView
        handleClose={handleClose}
        onDateChange={setSelectedScheduleDatesData}
        applicationId={applicationId}
        buildingName={developerBuilding?.name ?? ""}
        events={events}
      />
      <div className="d-flex justify-content-end gap-2 mt-3">
        {((!!selectedScheduleDatesData.length &&
          !roles.includes(FIRE_SAFETY_CONSUMER)) ||
          roles.includes(FIRE_SAFETY_CONSUMER)) && (
          <Button
            variant="contained"
            color="error"
            onClick={() => setIsRescheduleButtonClicked(true)}
          >
            {t("Reschedule")}
          </Button>
        )}

        <Button
          variant="contained"
          color="success"
          onClick={() => setIsApproveButtonClicked(true)}
        >
          {t("Approve")}
        </Button>
      </div>
    </Modal>
  );
};

AuditSchedularApproval.propTypes = {
  applicationId: PropTypes.number,
  handleClose: PropTypes.func,
  t: PropTypes.func,
  developerBuilding: PropTypes.object,
  events: PropTypes.array,
};

export default withTranslation()(AuditSchedularApproval);
